'use strict';

export function dispatchCommand() {
  console.warn('[Reanimated] dispatchCommand() is not supported on web.');
}
//# sourceMappingURL=dispatchCommand.web.js.map